<template>
    <div
        v-if="!tokenLoading"
        class="set-password"
    >
        <img
            src="/images/logo.png"
            alt="goTenna Pro Management Portal"
            class="logo"
        />

        <p
            v-if="!tokenValid"
            class="copy success text-center"
            data-test-id="reset-password-invalid-token-message"
        >
            Sorry, this link has already been used or is invalid.
        </p>

        <form
            v-if="tokenValid"
            data-test-id="reset-password-form"
            @submit.prevent="setPassword"
        >
            <p class="copy mb-20">Reset password for account:</p>

            <div
                v-if="!organizationName"
                class="privileged-notice mb-20"
                data-test-id="reset-password-privileged-notice"
            >
                <p class="privileged-notice__title">Privileged account</p>
                <p class="privileged-notice__body">This account is not part of any organization.</p>
            </div>

            <table class="mb-30 account-detail-table">
                <tbody>
                    <tr v-if="organizationName">
                        <th>Organization</th>
                        <td data-test-id="reset-password-organization">{{ organizationName }}</td>
                    </tr>
                    <tr>
                        <th>Email</th>
                        <td data-test-id="reset-password-email">{{ user.email }}</td>
                    </tr>
                </tbody>
            </table>

            <div class="form-group">
                <label for="password">Password</label>
                <input
                    id="password"
                    v-model="password"
                    data-test-id="reset-password-password-field"
                    type="password"
                    required
                    maxlength="255"
                />
            </div>

            <div class="form-group">
                <label for="password_confirmation">Confirm Password</label>
                <input
                    id="password_confirmation"
                    v-model="passwordConfirmation"
                    data-test-id="reset-password-password-confirmation-field"
                    type="password"
                    required
                    maxlength="255"
                />
            </div>

            <form-errors :response="errorResponse"></form-errors>

            <div class="form-group">
                <button
                    type="submit"
                    class="btn"
                    data-test-id="reset-password-submit-button"
                >
                    Submit
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import FormErrors from '@/components/FormErrors.vue'
import canToast from '@/mixins/canToast'

export default {
    components: {
        FormErrors,
    },

    mixins: [canToast],

    data() {
        return {
            password: null,
            passwordConfirmation: null,
            token: this.$route.params.token,
            tokenValid: false,
            tokenLoading: true,
            user: null,
            errorResponse: null,
        }
    },

    computed: {
        organizationName() {
            return this.user?.organization_name ?? null
        },
    },

    mounted() {
        this.$http
            .get(`auth/${this.token}/reset-password`)
            .then((response) => {
                this.user = response.data
                this.tokenValid = true
            })
            .catch(() => {
                this.tokenValid = false
            })
            .finally(() => {
                this.tokenLoading = false
            })
    },

    methods: {
        setPassword() {
            this.$http
                .post(`auth/${this.token}/reset-password`, {
                    password: this.password,
                    password_confirmation: this.passwordConfirmation,
                })
                .then(() => {
                    this.toast('Your password has successfully been reset!')
                    this.$router.push({ name: 'login' })
                })
                .catch((error) => {
                    if (error.response.status === 404) {
                        this.tokenValid = false
                    } else {
                        this.errorResponse = error.response
                    }
                })
        },
    },
}
</script>

<style scoped lang="scss">
@use '@sass/_variables.scss' as *;

.privileged-notice {
    border: 1px solid #ffb471;
    border-left-width: 3px;
    border-radius: 4px;
    padding: 12px 14px;
    background: rgba(255, 180, 113, 0.07);

    .privileged-notice__title {
        font-family: Arial;
        font-size: 0.75rem;
        font-weight: 700;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: #ffb471;
        margin-bottom: 5px;
    }

    .privileged-notice__body {
        font-size: 0.875rem;
        line-height: 1.45;
    }
}

.account-detail-table {
    width: 100%;

    th {
        text-align: left;
        font-family: Arial;
        font-size: 0.75rem;
        font-weight: 700;
        color: #ffb471;
        text-transform: uppercase;
    }

    th,
    td {
        padding: 5px 0;
    }
}
</style>
